export default __webpack_public_path__ + "static/media/ppv2.3884facd.png";